import{gql as o}from"@apollo/client";const r=o`
  mutation sendForgotPassword($projectId: String!, $userId: Int!) {
    user {
      sendForgotPassword(projectId: $projectId, userId: $userId)
    }
  }
`;export{r as SEND_FORGOT_PASSWORD_MUTATION};
//# sourceMappingURL=useSendForgotPassword.graphql.js.map
